import envVar from '../../config/envVars';
import httpGet from '../httpClient/httpGet';
import authenticationUtils from '../../utils/authenticationUtils';

const getConcessionsAndWaiversReport = (
  academicYear: string,
  page: number,
  perPage: number
) =>
  httpGet(
    `${envVar.REACT_APP_PAYMENTS_API_BASE_URL}/reports/concessions-and-waivers?academicYear=${academicYear}&page=${page}&perPage=${perPage}`,
    {
      headers: {
        Authorization: `Bearer ${authenticationUtils.getEasypayToken()}`
      }
    }
  );

export { getConcessionsAndWaiversReport };
